import { TZDate } from '@date-fns/tz';
import clsx from 'clsx';
import { type ReactNode, useMemo } from 'react';

import { calendarMonthRowCSS, calendarRowCSS } from '../Calendar.sty.js';
import { useSelectMonth } from '../hooks/useSelectMonth.js';
import { Month } from '../Month.js';
import {
  NUMBER_OF_MONTH_ROWS,
  NUMBER_OF_MONTHS_PER_ROW,
} from '../types/calendarConfiguration.js';

export interface SelectMonthViewItems {
  months: TZDate[];
}

/**
 * SelectMonthView component
 * Renders a grid of buttons for selecting the month
 */
export const SelectMonthView = () => {
  const { months } = useSelectMonth();
  const monthsToShow = useMemo(
    (): ReactNode =>
      new Array(NUMBER_OF_MONTH_ROWS).fill(0).map((_, index) => (
        <tr
          key={`${months[index]}-row-${index}`}
          className={clsx([calendarRowCSS, calendarMonthRowCSS])}
        >
          {months
            .slice(
              index * NUMBER_OF_MONTHS_PER_ROW,
              index * NUMBER_OF_MONTHS_PER_ROW + NUMBER_OF_MONTHS_PER_ROW,
            )
            .map((month) => (
              <Month date={month} key={month.toISOString()} />
            ))}
        </tr>
      )),
    [months],
  );

  return <tbody>{monthsToShow}</tbody>;
};
SelectMonthView['displayName'] = 'SelectMonthView';
